import '../generalMappings';

import { ButtonModel, ButtonDesign } from '../../models/Gen/TrackableBaseModels';
import {
    ButtonDescriptor,
    ButtonWidgetDescriptor,
    ButtonWidgetDataDescriptor,
    ButtonToursBlockDescriptor,
    RulesDescriptor,
    ButtonItemDescriptor,
    ButtonContentDescriptor,
    ButtonBadgeDescriptor,
    UrlFilterDescriptor
} from '../../site-config/trackableConfig';


ButtonModel.prototype._ModelExtender = function (model, p, pp, mappingOptions) {
    mappingOptions.descriptor = {
        create: function (options) {
            let mdl = new ButtonDescriptor(options.data);

            if (!mdl.widgets()) mdl.widgets([]);

            return mdl;
        }
    };
    mappingOptions.design = {
        create: function (options) {
            let mdl = new ButtonDesign(options.data);
            return mdl;
        }
    };
};
ButtonWidgetDescriptor.prototype._ModelExtender = function (model, p, pp, mappingOptions) {
    mappingOptions.data = {
        create: function (options) {
            let data = new ButtonWidgetDataDescriptor(options.data);

            return data;
        }
    };
};
ButtonDescriptor.prototype._ModelExtender = function (model, p, pp, mappingOptions) {
    mappingOptions.toursBlock = {
        create: function (options) {
            return new ButtonToursBlockDescriptor(options.data);
        }
    };
    mappingOptions.launchers = {
        create: function (options) {
            return new ButtonItemDescriptor(options.data);
        }
    };
    mappingOptions.badge = {
        create: function (options) {
            return new ButtonBadgeDescriptor(options.data);
        }
    };
    mappingOptions.urlFilter = {
        create: function (options) {
            return new UrlFilterDescriptor(options.data);
        }
    };
    mappingOptions.content = {
        create: function (options) {
            const cntDesc = new ButtonContentDescriptor(options.data);

            (ko.unwrap(cntDesc.items) || []).forEach(item => {
                item.__trackingEnabled && item.__trackingEnabled(false);
                item.opts(JSON.parse(ko.unwrap(item.opts)));
                item.__trackingEnabled && item.__trackingEnabled(true);

                const subs = ko.unwrap(item.subs);
                if (subs && subs[0]) {
                    subs.forEach(sub => {
                        sub.__trackingEnabled && sub.__trackingEnabled(false);
                        sub.opts(JSON.parse(ko.unwrap(sub.opts)));
                        sub.__trackingEnabled && sub.__trackingEnabled(true);
                    });
                }
            });

            return cntDesc;
        }
    };
};

ButtonItemDescriptor.prototype._ModelExtender = function (model, p, pp, mappingOptions) {
    mappingOptions.urlFilter = {
        create: function (options) {
            return new UrlFilterDescriptor(options.data);
        }
    };
    mappingOptions.rules = {
        create: function (options) {
            return new RulesDescriptor(options.data);
        }
    };
};


export default {};